import { Component } from "@kluntje/core";
import { ACTIVE } from "Helper/cssClasses";
import { toggleClass } from "@kluntje/js-utils/lib/dom-helpers";
import SSOService from "Services/SSOService";

/**
 * Custom Element to allow gigya logout when the user is logged in
 */
class FRALogoutButton extends Component {
  SSOService = SSOService.getInstance();

  constructor() {
    super({
      events: [
        {
          event: "click",
          target: "this",
          handler: "logOut",
        },
      ],

      initialStates: {
        loggedIn: false,
      },

      reactions: {
        loggedIn: ["toggleVisibility"],
      },
    });
  }

  /**
   * @override
   */
  afterComponentRender() {
    this.SSOService.subscribe(({ loggedIn }: { loggedIn: boolean }) => {
      this.setState({ loggedIn });
    });
  }

  /**
   * update ui on input change
   *
   * @param {UIEvent} _e - click event
   */
  logOut(_e: UIEvent): void {
    this.SSOService.logOut();
    // hide even before the user is really logged out
    this.setState({ loggedIn: false });
  }

  toggleVisibility({ loggedIn }: { loggedIn: boolean }) {
    toggleClass(this, ACTIVE, loggedIn);
  }
}

customElements.define("fra-e-logout-button", FRALogoutButton);

export default FRALogoutButton;
